import Vue from "vue";
import VueRouter from "vue-router";
import OptimizationPage from "../views/Optimization/OptimizationPage";

Vue.use(VueRouter);

const routes = [
  {
    path: "/odin",
    name: "Odin",
    component: () =>
      import(/* webpackChunkName: "odin" */ "../views/Odin/OdinPage.vue"),
    meta: {
      layout: "main-layout",
      mainAnchor: "#odin-main",
    },
  },
  {
    path: "/",
    name: "Optimization",
    component: OptimizationPage,
    meta: {
      layout: "main-layout",
      keepAlive: true, //  Need to be cached
    },
  },
  {
    path: "/development",
    name: "",
    component: () =>
      import(
        /* webpackChunkName: "optimization" */ "../views/Development/DevelopmentPage.vue"
      ),
    meta: {
      layout: "main-layout",
      keepAlive: true, //  Need to be cached
    },
  },
  {
    path: "/portfolio",
    name: "Portfolio",
    component: () =>
      import(
        /* webpackChunkName: "portfolio" */ "../views/Portfolio/PortfolioPage"
      ),
    meta: {
      layout: "main-layout",
      keepAlive: true,
    },
  },
  {
    path: "/contact",
    name: "Contact",
    component: () =>
      import(
        /* webpackChunkName: "contact" */ "../views/Contact/ContactPage.vue"
      ),
    meta: {
      layout: "main-layout",
      keepAlive: true,
    },
  },
  {
    path: "/about-us",
    name: "About",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About/AboutPage"),
    meta: {
      layout: "main-layout",
      keepAlive: true,
    },
  },
  {
    path: "/privacy-policy",
    name: "PrivacyPolicy",
    component: () =>
      import(/* webpackChunkName: "privacy" */ "../views/PrivacyPage"),
    meta: {
      layout: "policy-layout",
      keepAlive: true,
    },
  },
  {
    path: "/cookie-policy",
    name: "CookiePolicy",
    component: () =>
      import(/* webpackChunkName: "cookie" */ "../views/CookiePolicyPage"),
    meta: {
      layout: "policy-layout",
      keepAlive: true,
    },
  },
  {
    path: "/vacancies",
    name: "Vacancies",
    component: () =>
      import(
        /* webpackChunkName: "vacancies" */ "../views/Vacancies/VacanciesPage"
      ),
    meta: {
      layout: "policy-layout",
      keepAlive: true,
    },
  },
  {
    path: "/ari-ai",
    name: "AriAI",
    // Compatibility for navigation inside an already loaded SPA.
    // Direct requests receive a genuine HTTP 301 at the web-server layer.
    redirect: to => ({ path: "/odin", query: to.query, hash: to.hash }),
  },
  {
    path: "/ari-pulse",
    name: "AriPulse",
    component: () =>
      import(
        /* webpackChunkName: "gsc-snapshot" */ "../views/GSC/GscSnapshotPage.vue"
      ),
    meta: {
      layout: "main-layout",
      keepAlive: true,
    },
  },
  {
    path: "/privacy-ari-pulse",
    name: "AriPulsePrivacy",
    component: () =>
      import(
        /* webpackChunkName: "ari-pulse-privacy" */ "../views/AriPulsePrivacyPage.vue"
      ),
    meta: {
      layout: "policy-layout",
      keepAlive: true,
    },
  },
  {
    path: "/terms-ari-pulse",
    name: "AriPulseTerms",
    component: () =>
      import(
        /* webpackChunkName: "ari-pulse-terms" */ "../views/AriPulseTermsPage.vue"
      ),
    meta: {
      layout: "policy-layout",
      keepAlive: true,
    },
  },
  {
    path: "/games",
    name: "Games",
    component: () =>
      import(/* webpackChunkName: "games" */ "../views/Games/GamesPage.vue"),
    meta: {
      layout: "main-layout",
      keepAlive: true,
    },
  },
  {
    path: "/games/moonday", name: "MoonDay",
    component: () => import(/* webpackChunkName: "moonday" */ "../views/Games/MoonDayPage.vue"),
    meta: { layout: "main-layout", mainAnchor: "#moonday-content", hideBanner: true }
  },
  ...(process.env.VUE_APP_INCLUDE_REVIEW_DRAFTS === "true" ? [
  {
    path: "/games/moonday/privacy-policy", name: "MoonDayPrivacy",
    component: () => import(/* webpackChunkName: "product-legal" */ "../views/Games/ProductLegalPage.vue"),
    meta: { layout: "main-layout", mainAnchor: "#product-legal-content", hideBanner: true, productDocument: "moondayPrivacy" }
  },
  ] : []),
  ...(process.env.VUE_APP_INCLUDE_REVIEW_DRAFTS === "true" ? [
  {
    path: "/games/moonday/delete-data", name: "MoonDayDeletion",
    component: () => import(/* webpackChunkName: "product-legal" */ "../views/Games/ProductLegalPage.vue"),
    meta: { layout: "main-layout", mainAnchor: "#product-legal-content", hideBanner: true, productDocument: "moondayDeletion" }
  },
  ] : []),
  {
    path: "/games/tok-kids",
    name: "TokKids",
    component: () =>
      import(
        /* webpackChunkName: "tok-kids" */ "../views/Games/TokKidsPage.vue"
      ),
    meta: {
      layout: "main-layout",
      keepAlive: true,
    },
  },
  {
    path: "/android/apple-hunter",
    name: "AppleHunter",
    component: () =>
      import(
        /* webpackChunkName: "apple-hunter" */ "../views/Games/AppleHunterPage.vue"
      ),
    meta: {
      layout: "main-layout",
      keepAlive: true,
    },
  },
  {
    path: "/android/apple-hunter/privacy-apple-hunter",
    name: "AppleHunterPrivacy",
    component: () => process.env.VUE_APP_INCLUDE_REVIEW_DRAFTS === "true"
      ? import(/* webpackChunkName: "apple-hunter-privacy" */ "../views/Games/AppleHunterPrivacyPage.vue")
      : import(/* webpackChunkName: "apple-hunter-published-policy" */ "../views/Games/published/AppleHunterPrivacyPage.vue"),
    meta: {
      layout: "main-layout",
      productDocument: "appleHunterPrivacy",
      mainAnchor: "#product-legal-content",
      hideBanner: true,
      keepAlive: true,
    },
  },
  {
    path: "/android/apple-hunter/app.html",
    redirect: "/android/apple-hunter",
  },
  {
    path: "/android/apple-hunter/privacy-apple-hunter.html",
    redirect: "/android/apple-hunter/privacy-apple-hunter",
  },
  {
    path: "/games/ludomelix",
    name: "Ludomelix",
    component: () =>
      import(
        /* webpackChunkName: "ludomelix" */ "../views/Games/LudomelixPage.vue"
      ),
    meta: {
      layout: "main-layout",
      mainAnchor: "#lodomelix-content",
      hideBanner: true,
      keepAlive: true,
    },
  },
  ...(process.env.VUE_APP_INCLUDE_REVIEW_DRAFTS === "true" ? [
  {
    path: "/games/ludomelix/testing-terms",
    name: "LodomelixTestingTerms",
    component: () =>
      import(
        /* webpackChunkName: "lodomelix-terms" */ "../views/Games/LodomelixTestingTermsPage.vue"
      ),
    meta: {
      layout: "main-layout",
      mainAnchor: "#lodomelix-content",
      hideBanner: true,
    },
  },
  ] : []),
  ...(process.env.VUE_APP_INCLUDE_REVIEW_DRAFTS === "true" ? [
  {
    path: "/games/ludomelix/privacy-policy",
    name: "LodomelixPrivacy",
    component: () =>
      import(
        /* webpackChunkName: "lodomelix-privacy" */ "../views/Games/LodomelixPrivacyPage.vue"
      ),
    meta: {
      layout: "main-layout",
      mainAnchor: "#lodomelix-content",
      hideBanner: true,
    },
  },
  ] : []),
  ...(process.env.VUE_APP_INCLUDE_REVIEW_DRAFTS === "true" ? [
  {
    path: "/games/ludomelix/delete-account",
    name: "LodomelixDeletion",
    component: () =>
      import(
        /* webpackChunkName: "lodomelix-deletion" */ "../views/Games/LodomelixDeletionPage.vue"
      ),
    meta: {
      layout: "main-layout",
      mainAnchor: "#lodomelix-content",
      hideBanner: true,
    },
  },
  ] : []),
  {
    path: "/games/lord-of-apples",
    name: "LordOfApples",
    component: () =>
      import(
        /* webpackChunkName: "lord-of-apples" */ "../views/Games/LordOfApplesPage.vue"
      ),
    meta: {
      layout: "main-layout",
      keepAlive: true,
    },
  },
  {
    path: "/gsc-snapshot",
    redirect: "/ari-pulse",
  },
  {
    path: "/404",
    name: "404",
    component: () =>
      import(/* webpackChunkName: "not-found" */ "../views/404/NotFoundPage"),
    meta: {
      layout: "policy-layout",
      keepAlive: true,
    },
  },
  {
    path: "*",
    redirect: "/404",
  },
];

const scrollBehavior = function (to, from, savedPosition) {
  if ((to.path.startsWith("/games/ludomelix") || to.path.startsWith("/games/moonday") || to.path === "/android/apple-hunter/privacy-apple-hunter") && /^#[a-zA-Z0-9-]+$/.test(to.hash)) {
    return { selector: to.hash, offset: { x: 0, y: 100 } };
  }
  return { x: 0, y: 0 };
};

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior,
});

export default router;
